type IEstimate = {
  [key in "deposit" | "withdrawal" | "socketDeposit"]: {
    value: number;
    unit: string;
    // Optional display override. When set, the UI shows this verbatim instead of
    // `${value} ${unit}`. NOTE: `value`/`unit` are STILL used for ETA math
    // (moment durations, e.g. AccountModal's pending-tx countdown), so they must
    // remain valid moment inputs even when a label is present.
    label?: string;
  };
};

export const ONCHAIN_ESTIMATES: IEstimate = {
  deposit: {
    value: 1,
    unit: "minute",
    // Monad deposits confirm near-instantly; show "Immediate" while keeping the
    // 1-minute duration for the pending-tx countdown math.
    label: "Immediate",
  },
  socketDeposit: {
    value: 5,
    unit: "minutes",
  },
  withdrawal: {
    // A withdrawal is a direct on-chain transaction: it settles when the
    // transaction confirms. "3 hours" was left over from Aevo-era bridging.
    value: 1,
    unit: "minute",
    label: "Immediate",
  },
} as const;

// Display string for an estimate: the explicit `label` if set, otherwise
// `${value} ${unit}`. Use this everywhere the estimate is shown to the user so
// the wording stays consistent across every deposit/withdraw surface.
export const formatOnchainEstimate = (e: {
  value: number;
  unit: string;
  label?: string;
}): string => e.label ?? `${e.value} ${e.unit}`;
